@if ({ items: items$ | async, title: title$ | async }; as data) {
  @if (data.items !== null && data.title !== null) {
    <boels-carousel
      [items]="data.items"
      [title]="data.title"
      itemWidth="255px"
      [hideIndicators]="true"
      [template]="thumbs"
      [nextIcon]="faArrowRight"
      [previousIcon]="faArrowLeft"
    >
    </boels-carousel>
  }
}

<ng-template #thumbs let-item="item">
  <boels-product-card
    [$openInNewTab]="true"
    [$product]="item"
  ></boels-product-card>
</ng-template>
